import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './HomeBanner.css';

// Component
import HomeBannerForm from '../../../components/siteadmin/HomeBannerForm/HomeBannerForm';
import Loader from '../../../components/Loader/Loader';
import { withQuery } from '../../../hoc/withGraphql';

class HomeBanner extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getImageBanner: PropTypes.object,
    })
  };

  static defaultProps = {
    data: {
      loading: true,
      image: null
    }
  };


  render() {
    const { data: { loading, getImageBanner } } = this.props;
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <HomeBannerForm initialValues={getImageBanner} />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(gql`
        {
            getImageBanner {
                id
                title
                description
                buttonLabel
                image
            }
        }
      `, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(HomeBanner);
